<template>
  <div class="training-process-log"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="timeline !== false">
      <AppScrollbar v-if="timeline && timeline.length"
                    style="height: 100%; overflow-x: hidden">
        <div class="log-main">
          <el-timeline>
            <el-timeline-item v-for="(item, index) in timeline"
                              :key="index"
                              :timestamp="item.createDate || '--'"
                              type="primary"
                              placement="top">
              <div class="log-card">
                <div class="log-title">
                  <el-tag size="small" type="primary">{{item.title}}</el-tag>
                </div>
                <div class="log-content" v-if="item.content">{{item.content}}</div>
                <div class="log-files" v-if="item.fileList && item.fileList.length">
                  <div class="file-label">附件：</div>
                  <div class="file-links">
                    <a v-for="(file, fileIndex) in item.fileList"
                       :key="fileIndex"
                       :href="file.url"
                       target="_blank"
                       class="file-link">
                      <i class="el-icon-document"></i>
                      {{file.name}}
                    </a>
                  </div>
                </div>
                <div class="log-operator">操作人：{{item.operatorName || '--'}}</div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </AppScrollbar>
      <Hint v-else>
        <div>暂无{{ logTypeName }}流程记录</div>
      </Hint>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>{{ logTypeName }}流程记录加载失败</div>
        <el-button type="text"
                   @click="loadTimeline">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../elements/AppScrollbar'
import Hint from '../../../../../elements/Hint'
export default {
  name: 'TrainingProcessLog',
  components: {
    AppScrollbar,
    Hint
  },
  props: {
    extraParams: Object,
    visible: Boolean,
    // 请求URL
    apiUrl: {
      type: String,
      required: true
    },
    // 日志类型名称，用于显示提示文案
    logTypeName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      timeline: false
    }
  },
  computed: {
    groupId () {
      return this.$attrs['extra-id']
    }
  },
  methods: {
    loadTimeline () {
      if (!this.groupId) {
        this.$message.warning('缺少分组ID参数')
        return
      }
      this.loading = true
      this.$ajax({
        url: this.apiUrl,
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          groupId: this.groupId
        }, this.extraParams))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.timeline = response.data['timeline'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadTimeline()
  },
  watch: {
    visible: function (val) {
      if (val) {
        this.loadTimeline()
      }
    }
  }
}
</script>

<style lang="scss">
.training-process-log {
  width: 600px;
  height: 100%;
  overflow-x: hidden;
  .log-main {
    padding: 15px;
    .el-timeline {
      padding-left: 0;
      .el-timeline-item {
        .el-timeline-item__wrapper {
          .el-timeline-item__timestamp {
            color: #606266;
            font-size: 12px;
            font-weight: bold;
          }
          .el-timeline-item__content {
            .log-card {
              margin-top: 10px;
              margin-right: 15px;
              padding: 12px;
              background-color: #fff;
              border-radius: 5px;
              box-shadow: 0 1px 5px rgba(0,0,0,.1);
              .log-title {
                font-size: 14px;
                font-weight: bold;
                color: #303133;
              }
              .log-content {
                margin-top: 8px;
                font-size: 13px;
                color: #606266;
                &:empty {
                  display: none;
                }
              }
              .log-files {
                margin-top: 8px;
                .file-label {
                  font-size: 12px;
                  color: #909399;
                  margin-bottom: 4px;
                }
                .file-links {
                  display: flex;
                  flex-direction: column;
                  gap: 4px;
                  .file-link {
                    display: inline-flex;
                    align-items: center;
                    font-size: 13px;
                    color: #409EFF;
                    text-decoration: none;
                    &:hover {
                      color: #66b1ff;
                      text-decoration: underline;
                    }
                    i {
                      margin-right: 4px;
                    }
                  }
                }
              }
              .log-operator {
                margin-top: 8px;
                color: #909399;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
